import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export function useIsLoyaltyHomepageEnabled(): boolean {
  return useFlag('enable-loyalty-homepage');
}
